var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1675A9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    transform: "translate(-1156.369 -152.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    transform: "translate(1205.516 152.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    className: "st0",
    d: "M490.88,240c-165.69-0.02-300.01,134.29-300.03,299.97S325.14,839.98,490.82,840 c165.68,0.02,300.01-134.29,300.03-299.97C790.64,374.44,656.47,240.25,490.88,240z M565.47,550.54h-48.78v174h-72.4v-174h-34.36 v-61.5h34.36v-39.71c0-28.51,13.53-73.01,73.02-73.01l53.61,0.19v59.73h-38.89c-8.11-0.43-15.04,5.79-15.47,13.9 c-0.05,0.95-0.01,1.9,0.12,2.84v36.05h55.03L565.47,550.54z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/FACEBOOK.37818aeaf7b0dd5c862047add8b19870.svg";
export { ForwardRef as ReactComponent };